import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "w-full"
};
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    // See vite.config.ts for details about automatic imports
    const route = useRoute();
    useHead({
      title: () => route.meta.title || 'Vite + Vue Template',
      meta: [{
        property: 'og:title',
        content: route.meta.title
      }, {
        name: 'twitter:title',
        content: route.meta.title
      }]
    });
    const thisYear = new Date().getFullYear();
    return (_ctx, _cache) => {
      const _component_tabbar = _resolveComponent("tabbar");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_tabbar), _createElementVNode("main", null, [_createVNode(_component_router_view)])]);
    };
  }
});